import { useState, useRef, useEffect, Fragment, useMemo } from 'react'
import { inject, observer } from 'mobx-react';
import { createMultipleRef } from '../../helpers'
import { Card, Button, Input, ModalAlert, FormLoading } from '../../components'
import { UserService } from "../../services";
import { isEmpty } from 'lodash'
import { menuConfig } from '../../layout/MenuConfig'
import DataGrid, { SearchPanel, Toolbar, Item, Pager, Column, HeaderFilter } from 'devextreme-react/data-grid';
import { SearchIcon } from '@heroicons/react/outline';
import './style.css'
import { useTranslation } from 'react-i18next'

let firstRender = false
const Roles = inject("authenStore")(observer((props) => {
  const { t } = useTranslation(['roles', 'menu', 'common'])
  let authenStore = props.authenStore
  let { getAccountAuth } = authenStore // STATE
  let auth = { action_user_id: getAccountAuth?.user_id, token_id: getAccountAuth?.access_token }

  const [dataSource, setDatasource]: any = useState([])
  const [roleSetting, setRoleSetting]: any = useState({
    visible: false,
    groupId: "",
    groupName: "",
    roles: []
  })
  const [loading, setLoading]: any = useState({ visible: false, tip: 'loading' })
  const [optionAlert, setOptionAlert]: any = useState({
    show: false,
    action: {
      id: "",
      name: ""
    },
    type: "success",
    title: "",
    description: {
      visible: false,
      type: "",
      content: "",
      contentLists: [],
    }
  })


  const gridRef: any = useRef(null);
  const inputRef: any = useRef([]);
  createMultipleRef(inputRef, 4)

  useEffect(() => {
    if (firstRender || !isEmpty(getAccountAuth)) {
      getUserGroup()
    }
    else
      firstRender = true
  }, [getAccountAuth])

  const getUserGroup = () => {
    UserService.getUserGroup(auth)
      .then((res: any) => {
        setDatasource(res?.result || [])
      })
      .catch((err) => {
        setDatasource([])
      })
  }

  const getPermissionByGroup = (id, group_name) => {
    setLoading({ ...loading, visible: true, tip: 'loading' })
    UserService.getRoleByGroup(auth, id)
      .then((res: any) => {
        let { code, result, message, sys_message } = res
        if (code === 200) {
          setRoleSetting({
            visible: true,
            groupId: id,
            groupName: group_name,
            roles: result
          })
        }
        else {
          setRoleSetting({
            visible: false,
            groupId: "",
            groupName: "",
            roles: []
          })

          setOptionAlert({
            ...optionAlert,
            type: "danger",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: "ผิดพลาด",
            description: { visible: true, type: "text", content: `${message} ${sys_message}` }
          })
        }
        setLoading({ ...loading, visible: false })
      })
      .catch((err) => {
        setLoading({ ...loading, visible: false })
        setRoleSetting({
          visible: false,
          groupId: "",
          groupName: "",
          roles: []
        })
        setOptionAlert({
          ...optionAlert,
          type: "danger",
          show: true,
          action: {
            id: "",
            name: ""
          },
          title: "ผิดพลาด",
          description: { visible: true, type: "text", content: `${err}` }
        })
      })
  }

  const updateRoles = () => {
    setLoading({ ...loading, visible: true, tip: 'saving' })
    let data = {
      roles: roleSetting.roles
    }
    UserService.updateRoles(auth, data)
      .then((res: any) => {
        let { code, message, sys_message } = res

        if (code === 200) {
          setOptionAlert({
            ...optionAlert,
            type: "success",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: t('common:saved_successfully'),
            description: { visible: false, type: "text", content: " ", contentLists: [] }
          })
        }
        else {
          setOptionAlert({
            ...optionAlert,
            type: "danger",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: "ผิดพลาด",
            description: { visible: true, type: "text", content: `${message} ${sys_message}` }
          })
        }
        setLoading({ ...loading, visible: false })
      })
      .catch((err) => {
        setLoading({ ...loading, visible: false })
        setOptionAlert({
          ...optionAlert,
          type: "danger",
          show: true,
          action: {
            id: "",
            name: ""
          },
          title: "ผิดพลาด",
          description: { visible: true, type: "text", content: `${err}` }
        })
      })
  }

  const checkAllow = (id, isSubMenu = false) => {
    let allowSetting = {}
    if (isSubMenu) {
      allowSetting = roleSetting?.roles.find((item) => item.permission_code == id)
    }
    else {
      allowSetting = roleSetting?.roles.find((item) => item.main_code == id)
    }
    return allowSetting
  }

  const onCheckChange = (id, fieldName, checked, isSubMenu = false) => {
    let rolesCurrent = { ...roleSetting }
    let findIndex = -1
    if (isSubMenu)
      findIndex = rolesCurrent?.roles.findIndex((item) => item.permission_code == id)
    else
      findIndex = rolesCurrent?.roles.findIndex((item) => item.main_code == id)

    if (findIndex >= 0) {
      rolesCurrent.roles[findIndex][fieldName] = checked
    }
    setRoleSetting(rolesCurrent)
  }

  // 1) ทำ lookup set ไว้เช็คเร็ว ๆ
  const mainAllowedSet = useMemo(() => {
    return new Set(
      (roleSetting?.roles || [])
        .map((r: any) => Number(r?.main_code))
        .filter((n: number) => Number.isFinite(n))
    );
  }, [roleSetting?.roles]);

  const subAllowedSet = useMemo(() => {
    return new Set(
      (roleSetting?.roles || [])
        .map((r: any) => Number(r?.permission_code))
        .filter((n: number) => Number.isFinite(n))
    );
  }, [roleSetting?.roles]);

  // 2) กรองเมนูตาม roleSetting
  const menuByRole = useMemo(() => {
    return (menuConfig || [])
      .map((m: any) => {
        // มี subMenu -> กรอง subMenu ตาม permission_code
        if (Array.isArray(m?.subMenu) && m.subMenu.length > 0) {
          const filteredSub = m.subMenu.filter((sm: any) => subAllowedSet.has(Number(sm.id)));
          if (filteredSub.length === 0) return null; // ไม่มีสิทธิ์ใน submenu เลย -> ไม่แสดง main menu นี้
          return { ...m, subMenu: filteredSub };
        }

        // ไม่มี subMenu -> เช็ค main_code
        if (!mainAllowedSet.has(Number(m.id))) return null;
        return m;
      })
      .filter(Boolean);
  }, [menuConfig, mainAllowedSet, subAllowedSet]);

  return (
    <>
      <Card title={t('set_user_permissions')}>
        <FormLoading loading={loading.visible} tip={loading.tip}>

          {/* ✅ จากเดิม flex-row → ปรับเป็น flex-col lg:flex-row */}
          <div className="flex flex-col lg:flex-row">

            {/* ================= LEFT : GROUP LIST ================= */}
            <div className="w-full lg:w-1/4 p-2">

              <div className="mt-5 md:col-span-2 md:-mt-2">
                <DataGrid
                  ref={(ref) => gridRef.current = ref}
                  dataSource={dataSource}
                  keyExpr={'id'}
                  height="calc(100vh - 219px)"
                  showBorders={true}
                  columnAutoWidth={true}
                  hoverStateEnabled={true}
                >
                  <SearchPanel visible={true} />
                  <Pager visible={false} />
                  <HeaderFilter visible={true} />

                  <Column
                    dataField={"group_name"}
                    caption={t('user_group')}
                    allowFiltering={true}
                  />
                  <Column
                    dataField={"user_count"}
                    caption={t('application_menu')}
                    width={140}
                    allowFiltering={false}
                  />
                  <Column
                    fixed={true}
                    caption={t('settings')}
                    type="buttons"
                    width={70}
                    buttons={[
                      {
                        hint: t('settings'),
                        icon: "preferences",
                        visible: true,
                        onClick: (e) => {
                          e.cancel = "true"
                          let data = e.row.data
                          getPermissionByGroup(data.id, data.group_name)
                        }
                      }
                    ]}
                  />

                  <Toolbar>
                    <Item location="start">
                      <Input
                        icon={<SearchIcon className="w-5 h-5 text-gray-500" />}
                        placeholder={t('common:search')}
                        onChange={(e) => {
                          gridRef.current.instance.searchByText(e.target.value)
                        }}
                      />
                    </Item>
                  </Toolbar>

                </DataGrid>
              </div>

            </div>

            {/* ================= RIGHT : PERMISSION SETTING ================= */}
            {/* ✅ จากเดิม w-3/4 → w-full lg:w-3/4 */}
            <div className="w-full lg:w-3/4 -2 -my-2 -mx-4 sm:-mx-6 lg:-mx-8">

              <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8 mt-2">

                {
                  roleSetting.visible && (
                    <div className="flex flex-col lg:flex-row gap-2">

                      <div className="flex-1">
                        <span className="text-sm font-semibold rounded bg-blue-100 text-blue-800 px-2.5 py-0.5">
                          {t('user_group')} : {roleSetting.groupName}
                        </span>
                      </div>

                      <div className="flex flex-row gap-2 lg:flex-row-reverse mb-2">
                        <Button
                          text={t('common:save')}
                          width="w-20"
                          onClick={() =>
                            setOptionAlert({
                              ...optionAlert,
                              type: "confirm",
                              action: {
                                id: "",
                                name: 'save'
                              },
                              title: t('common:confirm'),
                              show: true,
                              description: { visible: true, type: "text", content: t('common:save_the_data'), contentLists: [] }
                            })}
                        />
                        <Button
                          text={t('restore')}
                          type="white"
                          width="w-20"
                          disabled={roleSetting.visible ? false : true}
                          onClick={() => getPermissionByGroup(roleSetting.groupId, roleSetting.groupName)}
                        />
                      </div>

                    </div>
                  )
                }

                {/* ================= TABLE ================= */}

                <div className={`${roleSetting.roles.length === 0 ? 'scrollbar-content' : 'scrollbar-content-setting'} shadow ring-1 ring-black ring-opacity-5 md:rounded-sm overflow-x-auto`}>
                  {
                    roleSetting.roles.length > 0 &&
                    <table className="min-w-full">
                      <thead className="bg-white">
                        <tr className="divide-x divide-gray-400">
                          <th
                            scope="col"
                            className="py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-gray-900 sm:pl-6"
                          >
                            {t("application_menu")}
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900 min-w-24 max-w-48"
                          >
                            {t("enable")}
                          </th>
                        </tr>
                      </thead>

                      <tbody className="bg-white">
                        {menuByRole.map((menu: any) => {
                          const mainMenuId = menu.id;

                          return (
                            <Fragment key={menu.name}>
                              {/* Header ของ main menu (แสดงเฉพาะ main ที่ผ่านการกรองแล้วเท่านั้น) */}
                              <tr className="border-t border-gray-200 z-50">
                                <th
                                  colSpan={7}
                                  scope="colgroup"
                                  className="bg-gray-50 px-4 py-2 text-left text-sm font-semibold text-gray-900 sm:px-6"
                                >
                                  {t(`menu:${menu.name}`)}
                                </th>
                              </tr>

                              {/* Sub menu */}
                              {menu?.subMenu ? (
                                menu.subMenu.map((sub: any, index: number) => {
                                  const subMenuId = sub.id;
                                  const allowSetting: any = checkAllow(subMenuId, true);

                                  return (
                                    <tr
                                      key={sub.name}
                                      className={`divide-x divide-gray-200 border-t ${index === 0 ? "border-gray-300" : "border-gray-200"
                                        }`}
                                    >
                                      <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                        <span className="ml-6">{t(`menu:${sub.name}`)}</span>
                                      </td>
                                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center">
                                        <input
                                          type="checkbox"
                                          checked={!!allowSetting?.is_read}
                                          disabled={!roleSetting.visible}
                                          onChange={(e) =>
                                            onCheckChange(subMenuId, "is_read", e.target.checked, true)
                                          }
                                          className={`h-6 w-6 rounded border-gray-300 text-primary-600 ${roleSetting.visible ? "cursor-pointer" : "cursor-not-allowed bg-gray-100"
                                            }`}
                                        />
                                      </td>
                                    </tr>
                                  );
                                })
                              ) : (
                                // ไม่มี subMenu (leaf main menu)
                                (() => {
                                  const allowSetting: any = checkAllow(mainMenuId); // ของเดิมคุณใช้งานได้เลย
                                  return (
                                    <tr key={menu.name} className="divide-x divide-gray-200 border-gray-200 border-t">
                                      <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                        <span className="ml-6">{t(`menu:${menu.name}`)}</span>
                                      </td>
                                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center">
                                        <input
                                          type="checkbox"
                                          checked={!!allowSetting?.is_read}
                                          disabled={!roleSetting.visible}
                                          onChange={(e) => onCheckChange(mainMenuId, "is_read", e.target.checked)}
                                          className={`h-6 w-6 rounded border-gray-300 text-primary-600 ${roleSetting.visible ? "cursor-pointer" : "cursor-not-allowed bg-gray-100"
                                            }`}
                                        />
                                      </td>
                                    </tr>
                                  );
                                })()
                              )}
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </table>
                  }

                </div>

              </div>
            </div>

          </div>

        </FormLoading>
      </Card>


      <ModalAlert
        {...optionAlert}
        onOk={(show) => {
          let { action } = optionAlert
          if (action.name === "save") updateRoles()

          setOptionAlert({ ...optionAlert, show: false })
        }}
        onCancel={() => {
          setOptionAlert({ ...optionAlert, show: false })
        }}
      />
    </>
  )
}))

export default Roles